import {curry} from 'ramda';
import tryToCatch from 'try-to-catch';

import {setNotificationAction as setNotification} from '@pluto/notification/Redux/NotificationActions';
import {createJiraIssue, createJiraMultipleIssue} from '@pluto/rest';
import {setQCWorkQueueAction} from '../../../../QCManager/Redux/QCManagerActions';

export const createJiraIssueAction = curry(async (params, dispatch) => {
    const {
        body,
        id,
        offset,
        limit,
    } = params;
    const [error] = await tryToCatch(createJiraIssue, {
        body,
        id,
    });
    
    if (!error) {
        dispatch(setNotification({
            type: 'success',
            text: 'New Jira issue successfully created',
        }));
        dispatch(setQCWorkQueueAction({
            offset,
            limit,
            contentItemType: [],
            contentPartnerId: [],
            qcJobStatus: [],
        }));
    } else {
        const {data: errorData} = error.response;
        
        dispatch(setNotification({
            type: 'error',
            text: errorData.message,
        }));
    }
});

export const createMultipleJiraIssueAction = curry(async (params, dispatch) => {
    const {
        body,
        offset,
        limit,
    } = params;
    const [error] = await tryToCatch(createJiraMultipleIssue, {
        body,
    });
    
    if (!error) {
        dispatch(setNotification({
            type: 'success',
            text: 'New Jira issue successfully created',
        }));
        dispatch(setQCWorkQueueAction({
            offset,
            limit,
            contentItemType: [],
            contentPartnerId: [],
            qcJobStatus: [],
        }));
    } else {
        const {data: errorData} = error.response;
        
        dispatch(setNotification({
            type: 'error',
            text: errorData.message,
        }));
    }
});
